<template>
  <b-container class='my-4'>
    <b-card-group deck>
        <b-card header="Login" header-tag="h1" header-class="h4" class="mx-auto" style="max-width: 540px;">
          <b-card-text>

            <b-alert v-model="isError" variant="danger">There was a problem validating your information.</b-alert>

            <b-form @submit.prevent="submit_form">

              <template v-if="!isLoading">
                <b-row class='form-group-row'>
                  <div class="col-12">
                    <b-form-group
                      id="username-group"
                      label="Username:"
                      label-for="username"
                      class="text-left"
                      >
                      <b-form-input
                        id="username"
                        v-model="form.username"
                        type="text"
                        placeholder="Username"
                        required
                        />
                    </b-form-group>
                  </div>

                  <div class="col-12">
                    <b-form-group
                      id="password-group"
                      label="Password:"
                      label-for="password"
                      class="text-left"
                      >
                      <b-form-input
                        id="password"
                        v-model="form.password"
                        type="password"
                        placeholder="Password"
                        required
                        />
                    </b-form-group>
                  </div>

                </b-row>
                <div class="login-actions text-right mt-4">
                  <b-button type="submit" variant="primary">Login</b-button>
                </div>
              </template>
              
              <div v-if="isLoading" class="text-center text-danger my-2">
                <b-spinner small></b-spinner>
                <strong class="ml-2">Validating Login Information...</strong>
              </div>
            </b-form>

          </b-card-text>
      </b-card>
    </b-card-group>
  </b-container>
</template>
<script>
// import axios from 'axios'
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers( 'auth' );
export default {
  data(){
    return {
      form: {
        username: '',
        password: ''
      },
      isError: false,
      isLoading: false
    }
  },
  methods: {

    async submit_form() {
      this.isError = false;
      this.isLoading = true;
      const result = await this.login( this.form );
      if ( result.success ) {
        const { redirect = false } = this.$route.query;
        let path = redirect ? decodeURI( redirect ) : '/';
        // strip server-added trailing slash so we don't re-enter the guard
        if ( path.length > 1 ) path = path.replace( /\/+$/, '' );
        // vue-router 3.1+ rejects the promise on redirect/duplicate nav
        this.$router.push({ path }).catch( () => {});
      } else {
        this.isError = true;
        this.isLoading = false;
      }
    },

    ...mapActions([
      'login'
    ]),

  }
}
</script>
